<template>
  <Dialog
    v-model:visible="isTransactionsMapDialogOpen"
    modal
    position="top"
    :draggable="false"
    :resizable="false"
    :style="{ width: '100vw', minHeight: '98vh' }"
    class="overflow-hidden max-h-[60vh]"
    content-class="overflow-hidden relative mx-2 p-0"
    :pt="{
      header: 'p-3! bg-transparent absolute top-0 left-3 w-full z-20',
      headerActions: {
        class: 'bg-white/70 rounded-full text-white hover:bg-white/90',
      }
    }"
  >
    <nav class="absolute top-8 left-1/2 -translate-x-1/2 w-full max-w-(--breakpoint-2xl) pt-4 pb-2 px-6 bg-transparent dark:bg-surface-900 flex flex-nowrap! items-center justify-between z-20">
      <TransactionsFilterComponent class="mr-2" @update:map-features="updateMapFeatures" />
      <TransactionsSearchComponent @update:map-features="updateMapFeatures" @location-selected="handleLocationSelected" />
      <div class="flex items-center gap-2">
        <TransactionsSettingsComponent />
        <LayerManagerComponent />
      </div>
    </nav>
    <div class="relative w-screen h-screen">
      <TransactionsMapComponent
        ref="transactionsMap"
        :geom="masterGeometry"
        @features-selected="handleFeaturesSelected"
      />
    </div>
    <TransactionsSidebarComponent :object-id="objectId" :margin-top="false" @toggleMark="toggleMark" />
    <MarkedTransactionsTableModal v-if="objectId" :object-id="objectId" />
  </Dialog>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import Dialog from 'primevue/dialog'
import { computed, ref } from 'vue'
import LayerManagerComponent from '@/components/map/LayerManagerComponent.vue'
import MarkedTransactionsTableModal from '@/components/transactions/MarkedTransactionsTableModal.vue'
import TransactionsFilterComponent from '@/components/transactions/TransactionsFilterComponent.vue'
import TransactionsMapComponent from '@/components/transactions/TransactionsMapComponent.vue'
import TransactionsSearchComponent from '@/components/transactions/TransactionsSearchComponent.vue'
import TransactionsSettingsComponent from '@/components/transactions/TransactionsSettingsComponent.vue'
import TransactionsSidebarComponent from '@/components/transactions/TransactionsSidebarComponent.vue'
import { useTransactionStore } from '@/stores/transaction'
import { useDetailStore } from '@/stores/useDetailStore'

defineProps({
  objectId: Number,
  objectGeom: Number,
})

const transactionStore = useTransactionStore()
const detailStore = useDetailStore()
const { isTransactionsMapDialogOpen } = storeToRefs(transactionStore)

const masterGeometry = computed(() => {
  return detailStore.ehrGeometry || null
})

const transactionsMap = ref(null)

const toggleMark = id => {
  transactionsMap.value.map.toggleMark(id)
}

const updateMapFeatures = () => {
  // Optional-chained: the auto-search on dialog open can fire before the
  // sibling map component has registered its ref.
  transactionsMap.value?.map?.addFeaturesToMap()
}

const handleLocationSelected = (location) => {
  if (location.viitepunkt_x && location.viitepunkt_y) {
    const center = [location.viitepunkt_x, location.viitepunkt_y]
    transactionsMap.value.map.panTo(center)
    transactionsMap.value.map.zoomTo(12)
    transactionsMap.value.map.addSearchHighlight(location)
  }
}

// Handler for feature selection event
const handleFeaturesSelected = ({ ids }) => {
  // Call the action (to be created next)
  transactionStore.handleMapFeatureSelection(ids)
}
</script>
